import React, {Component} from 'react';
import { Button } from 'react-bootstrap';

import DimensionCtrl from '../DimensionCtrl';
import MeasureCtrl from '../MeasureCtrl';
import FilterCtrl from '../FilterCtrl';
import { isEntity, isProperty } from '../../../data/utils';
import { SpatialEntity } from '../SpatialEntity';
import { IDimension, IFilter, IItem, IMeasure, IRange } from '../../../data/Query';
import RangeCtrl from '../RangeCtrl';

interface IBarFormState {
    dimension: IDimension | null,
    measure: IMeasure | null,
    spatial: IItem | null,
    filters: IFilter[],
    range: IRange | null
}

const configVersion = '2';

class BarForm extends Component<any, IBarFormState>  {
    constructor(props: any) {
        super(props);

        this.state = {
            dimension: null,
            measure: null,
            spatial: null,
            filters: [],
            range: null
        };
    }

    componentDidMount() {
        if(this.props.chartConfig) {
            this.initFromConfig(this.props.chartConfig);
        }
    }

    initFromConfig(config: any) {
        // Sending the object through the socket io removes class types.
        // Get the type entity or property from the definition. The types
        // are used in the components.
        //
        console.log('bar chart > initFromConfig', config, this.props.definition, config);

        let dimension: IDimension = {
            source: {
                item: config.dimension.source && config.dimension.source.item ? this.getItemFromDefinition(config.dimension.source.item) : null,
                sub: config.dimension.source ? config.dimension.source.sub : null
            },
            bin: config.dimension.bin
        };

        let measure: IMeasure = {
            source: {
                item: config.measure.source && config.measure.source.item ? this.getItemFromDefinition(config.measure.source.item) : null,
                sub: config.measure.source ? config.measure.source.sub : null
            },
            aggregation: config.measure.aggregation
        };

        let spatial: IItem = {
            item: config.spatial && config.spatial.item ? this.getItemFromDefinition(config.spatial.item) : null,
            sub: null
        };

        let filters = config.filters.map((filter:IFilter) : IFilter => {
            const f: IFilter = {
                source: {
                    item: filter.source && filter.source.item ? this.getItemFromDefinition(filter.source.item) : null,
                    sub: filter.source.sub
                },
                operation: filter.operation,
                value: filter.value
            };

            return f;
        });

        let range = config.yRange ? {...config.yRange} : {min: null, max: null};
        
        this.setState({
            dimension,
            measure,
            spatial,
            filters,
            range: range
        });
    }

    saveToConfig(e: any) {
        e.preventDefault();

        let config = {
            version: configVersion,
            dimension: this.state.dimension,
            measure: this.state.measure,
            spatial: this.state.spatial,
            filters: this.state.filters,
            yRange: this.state.range
        };

        console.log('bar chart > saving config', config);

        // pass back to caller.
        if(this.props.saveConfig) {
            this.props.saveConfig(config);
        }
    }

    validate() : boolean {
        // for now, ensure we have a dimension and measure.
        return this.state.dimension != null && this.state.dimension.source.item != null &&
            this.state.measure != null && this.state.measure.source.item != null;
    }

    getItemFromDefinition(item:any) {
        let defItem = item;

        // main entity.
        if(item.name === this.props.definition.name) {
            return this.props.definition;
        }

        if(isEntity(item)) {
            defItem = this.props.definition.entity.find((i:any) => {
                return i.name === item.name;
            });
        } else if(isProperty(item)) {
            defItem = this.props.definition.property.find((i:any) => {
                return i.name === item.name;
            });
        }

        return defItem;
    }

    render() {
        const {range} = this.state;
        return (
            <div>
                <h5>Data</h5>
                <div className="mb-3 p-3 bg-dark">
                    <DimensionCtrl
                        definition={this.props.definition}
                        config={this.state.dimension}
                        includeRoot={true}
                        onUpdate={(e:any) => this.onDimenstionUpdate(e)}>
                    </DimensionCtrl>

                    <MeasureCtrl
                        definition={this.props.definition}
                        measure={this.state.measure}
                        onUpdate={(e:any) => this.onMeasureUpdate(e)}>
                    </MeasureCtrl>

                    <SpatialEntity
                        definition={this.props.definition}
                        item={this.state.spatial}
                        onUpdate={(e:any) => this.onSpatialUpdate(e)}
                    />
                    <FilterCtrl
                        definition={this.props.definition}
                        config={this.state.filters}
                        onUpdate={(e:any) => this.onFiltersUpdate(e)}>
                    </FilterCtrl>           
                </div>

                <h5>Display</h5>
                <div className="p-3 bg-dark mb-3">
                    <RangeCtrl
                        minTitle="Minimum Y Axis Value"
                        maxTitle="Maximum Y Axis Value"
                        min={range ? range.min : null} 
                        max={range ? range.max : null} 
                        onUpdate={(e:any) => this.onRangeUpdate(e)} />
                </div>

                <Button
                    variant="primary"
                    type="submit"
                    disabled={!this.validate()}
                    onClick={this.saveToConfig.bind(this)}>
                    Apply
                </Button>
            </div>   
        );
    }

    onDimenstionUpdate(config: any) {
        this.setState({
            dimension: config
        });
    }

    onMeasureUpdate(measure: IMeasure) {
        this.setState({
            measure: measure
        });
    }

    onFiltersUpdate(filters: IFilter[]) {
        this.setState({
            filters: filters
        });
    }

    onSpatialUpdate(item: IItem) {
        this.setState({
            spatial: item
        });
    }

    onRangeUpdate(range: IRange) {
        this.setState({
            range
        });
    }
}

export default BarForm;
